import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import OOPBuySpreadsheetGuide from "@/pages/article/oopbuy-spreadsheet-guide/page";
import VersandGuide from "@/pages/article/oopbuy-spreadsheet-versand-guide/page";
import QCCheckliste from "@/pages/article/oopbuy-spreadsheet-qc-checkliste/page";
import Sicherheit from "@/pages/article/oopbuy-spreadsheet-sicherheit/page";
import Anfaenger from "@/pages/article/oopbuy-spreadsheet-anfaenger/page";
import SneakerGuide from "@/pages/article/oopbuy-spreadsheet-sneaker-guide/page";
import VerkaeuferGuide from "@/pages/article/oopbuy-spreadsheet-verkaufer-bewertung/page";
import ZollGuide from "@/pages/article/oopbuy-spreadsheet-zoll-deutschland/page";
import HoodieJacketGuide from "@/pages/article/oopbuy-spreadsheet-hoodie-jacket-guide/page";
import Preisvergleich from "@/pages/article/oopbuy-spreadsheet-preisvergleich/page";
import BesteSchuhe from "@/pages/landing/beste-schuhe/page";
import BesteHoodies from "@/pages/landing/beste-hoodies/page";
import BesteVerkaufer from "@/pages/landing/beste-verkaeufer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <OOPBuySpreadsheetGuide />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-versand-guide",
    element: <VersandGuide />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-qc-checkliste",
    element: <QCCheckliste />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-sicherheit",
    element: <Sicherheit />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-anfaenger",
    element: <Anfaenger />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-sneaker-guide",
    element: <SneakerGuide />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-verkaufer-bewertung",
    element: <VerkaeuferGuide />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-zoll-deutschland",
    element: <ZollGuide />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-hoodie-jacket-guide",
    element: <HoodieJacketGuide />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-preisvergleich",
    element: <Preisvergleich />,
  },
  {
    path: "/landing/beste-schuhe",
    element: <BesteSchuhe />,
  },
  {
    path: "/landing/beste-hoodies",
    element: <BesteHoodies />,
  },
  {
    path: "/landing/beste-verkaeufer",
    element: <BesteVerkaufer />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;